import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/monthlyReports/importer/monthlyReportsImporterActions';

export default importerReducers(actions);
